module.exports = __webpack_public_path__ + "static/img/IN.34d08e0e.svg";